import {
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography,
} from '@mui/material';

type CampoInfoProps = {
  label: string;
  value: string | number | null | undefined;
};

function CampoInfo({ label, value }: CampoInfoProps) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Typography variant="subtitle2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1" fontWeight={500}>
        {value ?? '-'}
      </Typography>
    </Grid>
  );
}

type TabInfoGeneralProps = {
  clienteData: any;
};

export default function TabInfoGeneral({ clienteData }: TabInfoGeneralProps) {
  const contrato = clienteData?.contratos?.[0];

  return (
    <Grid item xs={12}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Informacion del Cliente
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2}>
            <CampoInfo label="Identificacion" value={clienteData?.identificacion} />
            <CampoInfo label="Razon Social" value={clienteData?.razon_social} />
            <CampoInfo label="Tipo Identificacion" value={clienteData?.tipo_identificacion} />
            <CampoInfo label="Celular" value={clienteData?.celular} />
            <CampoInfo label="Celular 2" value={clienteData?.celular_2} />
            <CampoInfo label="Email" value={clienteData?.email} />
            <CampoInfo label="Direccion" value={clienteData?.direccion} />
            <CampoInfo label="Coordenadas" value={clienteData?.coordenadas} />
          </Grid>

          {contrato && (
            <>
              <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }} gutterBottom>
                Contrato Principal
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <CampoInfo label="Codigo Contrato" value={contrato.codigo} />
                <CampoInfo label="Plan" value={contrato.plan} />
                <CampoInfo label="Velocidad" value={contrato.velocidad} />
                <CampoInfo label="Valor Plan" value={contrato.valor_plan ? `$${contrato.valor_plan}` : null} />
                <CampoInfo label="Tipo Plan" value={contrato.tipo_plan} />
                <CampoInfo label="Tipo Servicio" value={contrato.tipo_servicio} />
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Estado Servicio
                  </Typography>
                  <Chip
                    label={contrato.estado_servicio || contrato.estado_contrato || '-'}
                    size="small"
                    color={(contrato.estado_servicio || contrato.estado_contrato) === 'ACTIVO' ? 'success' : 'default'}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Typography variant="subtitle2" color="text.secondary">IP</Typography>
                  {contrato.ipv4_actual ? (
                    <Typography
                      variant="body2"
                      component="a"
                      href={`http://${contrato.ipv4_actual}:80`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                    >
                      {contrato.ipv4_actual}
                    </Typography>
                  ) : (
                    <Typography variant="body2">-</Typography>
                  )}
                </Grid>
                <CampoInfo label="Direccion Servicio" value={contrato.direccion} />
              </Grid>
            </>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}
